/* Shopify variant data is the sole source of price, availability and submitted IDs. */
(function ($) {
  'use strict';
  if (window.MaisonProductForms) return;
  var controllers = new WeakMap();
  var labels = window.inventory_text;

  function initializeProductWhatsApp(root, product) {
    var link = root.querySelector('[data-maison-product-whatsapp][data-whatsapp-phone]');
    if (!link || !product || !product.title || !product.url) return;
    var productUrl = new URL(product.url, window.location.origin);
    productUrl.search = '';
    productUrl.hash = '';
    var template = link.dataset.messageTemplate || '';
    var namePlaceholder = '{{product_name}}';
    var urlPlaceholder = '{{product_url}}';
    var hasName = template.indexOf(namePlaceholder) !== -1;
    var hasUrl = template.indexOf(urlPlaceholder) !== -1;
    var message = template.split(namePlaceholder).join(product.title).split(urlPlaceholder).join(productUrl.href).trim();
    if (!hasName) message = [message, product.title].filter(Boolean).join(' ');
    if (!hasUrl) message = [message, productUrl.href].filter(Boolean).join(' ');
    link.href = 'https://wa.me/' + link.dataset.whatsappPhone + '?text=' + encodeURIComponent(message);
    link.hidden = false;
  }

  function init(root, product, historyEnabled) {
    var form = root.querySelector('[data-maison-product-form]');
    if (!form || controllers.has(form) || !product.variants || !product.variants.length) return;
    initializeProductWhatsApp(root, product);
    var $root = $(root), $form = $(form), idControl = form.querySelector('[name="id"]');
    var variants = product.variants, selected, options = [], optionControls = [], optionWrappers = [];
    var caratControl = form.querySelector('[data-maison-carat-control]');
    var caratIndex = caratControl ? Number(caratControl.dataset.optionIndex) : -1;
    var caratButtons = caratControl ? Array.from(caratControl.querySelectorAll('[data-maison-carat-value]')) : [];
    var metalControl = form.querySelector('[data-maison-metal-control]');
    var metalIndex = metalControl ? Number(metalControl.dataset.optionIndex) : -1;
    var metalButtons = metalControl ? Array.from(metalControl.querySelectorAll('[data-maison-metal-value]')) : [];
    var productPage = root.querySelector('[data-maison-product-page]');
    var madeToOrder = !!(productPage && productPage.dataset.maisonMadeToOrder === 'true');
    var madeToOrderLabel = productPage ? productPage.dataset.maisonMadeToOrderLabel : '';
    var addLabel = form.dataset.maisonAddLabel || labels.add_to_cart;
    var variantById = function (id) { return variants.find(function (v) { return String(v.id) === String(id); }); };
    var initial = variantById(historyEnabled ? new URL(location.href).searchParams.get('variant') : idControl.value);
    initial = initial || variantById(idControl.value) || variants.find(function (v) { return v.available; }) || variants[0];
    options = initial.options.slice();

    function approvedProperty(name) {
      var control = form.elements['properties[' + name + ']'];
      if (!control || typeof control.value !== 'string') return null;
      var value = control.value.trim();
      return value || null;
    }

    function dispatchConfiguration(variant) {
      var detail = {
        version: 1,
        productId: product.id,
        variantId: variant ? variant.id : null,
        variantTitle: variant ? variant.title : null,
        price: variant ? variant.price : null,
        available: !!(variant && variant.available),
        carat: caratIndex >= 0 ? options[caratIndex] : null,
        metal: metalIndex >= 0 ? options[metalIndex] : null,
        ringSize: approvedProperty('Ring Size'),
        engraving: approvedProperty('Engraving')
      };
      form.dispatchEvent(new CustomEvent('maison:configuration:change', { bubbles: true, detail: detail }));
    }

    if (variants.length > 1) {
      product.options.forEach(function (option, index) {
        var name = typeof option === 'string' ? option : option.name;
        var wrapper = document.createElement('div'), label = document.createElement('label'), select = document.createElement('select');
        wrapper.className = 'selector-wrapper';
        select.id = form.getAttribute('id') + '-Option-' + index;
        select.className = 'single-option-selector';
        select.dataset.maisonOption = index;
        label.htmlFor = select.id;
        label.textContent = name;
        Array.from(new Set(variants.map(function (v) { return v.options[index]; }))).forEach(function (value) {
          select.add(new Option(value, value));
        });
        select.value = options[index];
        wrapper.append(label, select);
        idControl.before(wrapper);
        optionControls[index] = select;
        optionWrappers[index] = wrapper;
        if (form.querySelector('.swatch[data-option-index="' + index + '"]')) wrapper.hidden = true;
      });
    }
    idControl.hidden = true;
    $form.find('[data-maison-swatches]').prop('hidden', false);

    function syncMedia(variant) {
      var image = variant && variant.featured_image;
      if (!image) return;
      if (root.querySelector('[data-maison-media-gallery]')) {
        root.dispatchEvent(new CustomEvent('maison:variant-media', { detail: { image: image } }));
        return;
      }
      var src = image.src, images = $root.find('.engoj_img_main, .engoj_img_main_quickview');
      images.each(function () {
        this.src = src;
        this.dataset.src = src;
        this.removeAttribute('srcset');
        this.removeAttribute('data-srcset');
        if (image.alt) this.alt = image.alt;
      });
      $root.find('.zoomLens').css('background-image', 'url("' + src + '")');
    }

    function optionState(optionIndex, value) {
      var matches = variants.filter(function (candidate) {
        return candidate.options.every(function (candidateValue, index) {
          return index === optionIndex ? candidateValue === value : candidateValue === options[index];
        });
      });
      if (!matches.length) return 'unavailable';
      return matches.some(function (candidate) { return candidate.available; }) ? 'available' : 'sold-out';
    }

    function sync(variant, updateUrl) {
      selected = variant;
      var available = !!(variant && variant.available);
      var busy = form.dataset.maisonSubmitting === 'true';
      idControl.disabled = !available;
      idControl.value = variant ? String(variant.id) : '';
      optionControls.forEach(function (select, index) { select.value = options[index]; });
      if (caratControl && caratIndex >= 0) {
        var selectedIndex = -1;
        var output = caratControl.querySelector('[data-maison-carat-output]');
        caratButtons.forEach(function (button, index) {
          var value = button.dataset.maisonCaratValue;
          var state = optionState(caratIndex, value);
          var checked = value === options[caratIndex];
          if (checked) selectedIndex = index;
          button.dataset.maisonCaratState = state;
          button.setAttribute('aria-checked', checked ? 'true' : 'false');
          button.setAttribute('aria-disabled', state === 'available' ? 'false' : 'true');
          button.tabIndex = checked ? 0 : -1;
          button.classList.toggle('is-selected', checked);
          var labelTemplate = state === 'available' ? (checked ? form.dataset.maisonCaratSelectedLabel : form.dataset.maisonCaratAvailableLabel) : (state === 'sold-out' ? form.dataset.maisonCaratSoldOutLabel : form.dataset.maisonCaratUnavailableLabel);
          button.setAttribute('aria-label', (labelTemplate || '[value]').replace('[value]', value));
        });
        caratButtons.forEach(function (button, index) { button.classList.toggle('is-complete', selectedIndex >= 0 && index <= selectedIndex); });
        if (output) output.textContent = options[caratIndex] || '';
      }
      if (metalControl && metalIndex >= 0) {
        var metalOutput = metalControl.querySelector('[data-maison-metal-output]');
        metalButtons.forEach(function (button) {
          var value = button.dataset.maisonMetalValue;
          var displayValue = button.dataset.maisonMetalLabel || value;
          var state = optionState(metalIndex, value);
          var checked = value === options[metalIndex];
          button.dataset.maisonMetalState = state;
          button.setAttribute('aria-checked', checked ? 'true' : 'false');
          button.setAttribute('aria-disabled', state === 'available' ? 'false' : 'true');
          button.tabIndex = checked ? 0 : -1;
          button.classList.toggle('is-selected', checked);
          var labelTemplate = state === 'available' ? (checked ? form.dataset.maisonMetalSelectedLabel : form.dataset.maisonMetalAvailableLabel) : (state === 'sold-out' ? form.dataset.maisonMetalSoldOutLabel : form.dataset.maisonMetalUnavailableLabel);
          button.setAttribute('aria-label', (labelTemplate || '[value]').replace('[value]', displayValue));
        });
        var selectedMetal = metalButtons.find(function (button) { return button.dataset.maisonMetalValue === options[metalIndex]; });
        if (metalOutput) metalOutput.textContent = selectedMetal ? selectedMetal.dataset.maisonMetalLabel : '';
      }
      $form.find('.swatch').each(function () {
        var index = Number(this.dataset.optionIndex);
        $(this).find(':radio').each(function () {
          this.checked = this.value === options[index];
          // Keep possible choices reachable across dimensions; the resolved combination must be available to submit.
          this.disabled = !variants.some(function (v) { return v.available && v.options[index] === this.value; }, this);
          $(this).closest('[data-value]').toggleClass('soldout', this.disabled).toggleClass('available', !this.disabled);
        });
      });
      var text = variant ? (available ? addLabel : labels.sold_out) : labels.unavailable;
      $form.find('button[type="submit"]').prop('disabled', !available || busy).toggleClass('disabled', !available).text(text);
      $root.find('.btn-add-stickycart').prop('disabled', !available || busy).toggleClass('disabled', !available).text(text);
      $form.find('.shopify-payment-button').prop('hidden', !available || busy);
      $root.find('.engoj-variant-sku').text(variant ? variant.sku : '');
      $root.find('[data-maison-availability]').text(variant ? (available ? (madeToOrder ? madeToOrderLabel : labels.in_stock) : labels.out_of_stock) : labels.unavailable);
      if (variant) {
        $root.find('.enj-product-price, [data-maison-price]').html(Shopify.formatMoney(variant.price, window.money_format));
        $root.find('.enj-product-price-compare, [data-maison-compare-price]').prop('hidden', !(variant.compare_at_price > variant.price)).html(variant.compare_at_price > variant.price ? Shopify.formatMoney(variant.compare_at_price, window.money_format) : '');
        syncMedia(variant);
      } else {
        $root.find('.enj-product-price, [data-maison-price]').text(labels.unavailable);
        $root.find('.enj-product-price-compare, [data-maison-compare-price]').prop('hidden', true);
      }
      if (historyEnabled && updateUrl) {
        var url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
      dispatchConfiguration(variant);
      // Native product forms and accelerated checkout observe the real variant control.
      idControl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function resolve() {
      sync(variants.find(function (v) { return v.options.every(function (value, index) { return value === options[index]; }); }), true);
    }
    $form.on('click.maisonQuantity', '.js-qty__adjust', function (event) {
      event.preventDefault();
      if (form.dataset.maisonSubmitting === 'true' || form.getAttribute('aria-busy') === 'true') return;
      var quantity = form.querySelector('[name="quantity"]');
      var value = Number(quantity.value);
      quantity.value = Math.max(1, (Number.isInteger(value) ? value : 1) + (this.classList.contains('js-qty__adjust--plus') ? 1 : -1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    $form.on('change.maisonVariant', '[data-maison-option], .swatch :radio', function () {
      var index = this.dataset.maisonOption === undefined ? Number(this.closest('.swatch').dataset.optionIndex) : Number(this.dataset.maisonOption);
      options[index] = this.value;
      resolve();
    });
    $form.on('click.maisonCarat', '[data-maison-carat-value]', function () {
      if (this.getAttribute('aria-disabled') === 'true' || form.dataset.maisonSubmitting === 'true' || form.getAttribute('aria-busy') === 'true') return;
      options[caratIndex] = this.dataset.maisonCaratValue;
      resolve();
      this.focus();
    });
    $form.on('keydown.maisonCarat', '[data-maison-carat-value]', function (event) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      var enabled = caratButtons.filter(function (button) { return button.getAttribute('aria-disabled') !== 'true'; });
      if (!enabled.length) return;
      event.preventDefault();
      var current = enabled.indexOf(this);
      var target;
      if (event.key === 'Home') target = enabled[0];
      else if (event.key === 'End') target = enabled[enabled.length - 1];
      else {
        var direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        target = enabled[(Math.max(0, current) + direction + enabled.length) % enabled.length];
      }
      target.click();
    });
    $form.on('click.maisonMetal', '[data-maison-metal-value]', function () {
      if (this.getAttribute('aria-disabled') === 'true' || form.dataset.maisonSubmitting === 'true' || form.getAttribute('aria-busy') === 'true') return;
      options[metalIndex] = this.dataset.maisonMetalValue;
      resolve();
      this.focus();
    });
    $form.on('keydown.maisonMetal', '[data-maison-metal-value]', function (event) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      var enabled = metalButtons.filter(function (button) { return button.getAttribute('aria-disabled') !== 'true'; });
      if (!enabled.length) return;
      event.preventDefault();
      var current = enabled.indexOf(this);
      var target;
      if (event.key === 'Home') target = enabled[0];
      else if (event.key === 'End') target = enabled[enabled.length - 1];
      else {
        var direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        target = enabled[(Math.max(0, current) + direction + enabled.length) % enabled.length];
      }
      target.click();
    });
    $form.on('change.maisonVariant', '[name="id"]', function (event) {
      if (!event.originalEvent || !event.originalEvent.isTrusted) return;
      var variant = variantById(this.value);
      if (variant) options = variant.options.slice();
      sync(variant, true);
    });
    $form.on('input.maisonConfiguration change.maisonConfiguration', '[name="properties[Ring Size]"], [name="properties[Engraving]"]', function () {
      dispatchConfiguration(selected);
    });
    var controller = {
      refresh: function () { sync(selected, false); },
      valid: function () { return !!(selected && selected.available && String(selected.id) === idControl.value && !idControl.disabled); },
      fromUrl: function () {
        var variant = variantById(new URL(location.href).searchParams.get('variant')) || variants.find(function (v) { return v.available; }) || variants[0];
        options = variant.options.slice();
        sync(variant, false);
      }
    };
    controllers.set(form, controller);
    form.addEventListener('submit', function (event) {
      var quantity = form.querySelector('[name="quantity"]');
      if (!controller.valid() || form.dataset.maisonSubmitting === 'true' || (quantity && (!Number.isInteger(Number(quantity.value)) || Number(quantity.value) < 1))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    $root.on('click.maisonSticky', '.btn-add-stickycart', function (event) {
      event.preventDefault();
      if (controller.valid() && form.checkValidity() && form.dataset.maisonSubmitting !== 'true') form.requestSubmit();
    });
    sync(initial, false);
    if (caratControl && caratIndex >= 0 && optionWrappers[caratIndex]) {
      optionWrappers[caratIndex].hidden = true;
      caratControl.hidden = false;
    }
    if (metalControl && metalIndex >= 0 && optionWrappers[metalIndex]) {
      optionWrappers[metalIndex].hidden = true;
      metalControl.hidden = false;
    }
  }
  window.MaisonProductForms = { init: init, refresh: function (form) { var c = controllers.get(form); if (c) c.refresh(); }, valid: function (form) { var c = controllers.get(form); return c ? c.valid() : false; } };
  $(function () {
    document.querySelectorAll('[data-maison-product]').forEach(function (root) {
      init(root, JSON.parse(root.querySelector('[data-maison-product-json]').textContent), true);
    });
  });
  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-maison-product] [data-maison-product-form]').forEach(function (form) {
      var controller = controllers.get(form);
      if (controller) controller.fromUrl();
    });
  });
})(jQuery);
